import React, { useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { httpAdmin } from "../../../Apis/commonApis";
import { ShowSwal } from "../../../utils/alertSwal";
import { useSelector } from "react-redux";
import { disablePastDate } from "../../../utils/CommonFunctions";

function NextReviewModal({ open, handleClose, fetchCarePlanPdfs }) {
  const { clientCarePlanPdfData } = useSelector(
    (state) => state?.clientCarePlanReducer
  );

  const [review, setReview] = useState("");

  const documentId = useMemo(() => {
    return clientCarePlanPdfData[0]?._id;
  }, [clientCarePlanPdfData]);

  const addNextReviewDate = async () => {
    if (review && documentId) {
      handleClose();
      const endpoint = `editClientCarePlanPdf?documentId=${documentId}`;
      const body = { review };
      const res = await httpAdmin(endpoint, "post", body, null);
      if (res.status) {
        fetchCarePlanPdfs();
      }
      ShowSwal(res.status, res.message);
    }
  };

  return (
    <Modal className="viewModal" show={open} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>
          <span>Set Next Review Date</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          {documentId ? (
            <div className="col-md-12 mb-3">
              <label className="form-label">Date</label>
              <input
                type="date"
                className="form-control"
                min={disablePastDate()}
                value={review}
                onChange={(e) => setReview(e.target.value)}
              />
            </div>
          ) : (
            <div className="my-2">
              Generate careplan first and then set reminder date.{" "}
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex">
          <button className="btn submitBtn" onClick={handleClose}>
            No
          </button>
          <button
            disabled={!documentId}
            className="btn submitBtn"
            onClick={addNextReviewDate}
          >
            Yes
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default NextReviewModal;
